import ApiClient from '@afosto/api/ApiClient';

class Payments {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Add payment
   *
   * @param {string} secret
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Start a payment for a transaction
   * @returns {Promise}
   */
  createPayment(secret, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/transactions/${secret}/payments`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Create refund
   *
   * @param {string} secret
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create a refund for the given transaction
   * @returns {Promise}
   */
  createRefund(secret, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/transactions/${secret}/refunds`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Execute payment
   *
   * @param {string} secret
   * @param {Object} options - The additional request options
   * @description Start a payment for a transaction at the provider
   * @returns {Promise}
   */
  executePaymentTransaction(secret, options = {}) {
    return this.apiClient.request({
      url: `/odr/payments/${secret}/execute`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get live payment information
   *
   * @param {string} secret
   * @param {Object} options - The additional request options
   * @description Returns the live details of a payment
   * @returns {Promise}
   */
  getPayment(secret, options = {}) {
    return this.apiClient.request({
      url: `/odr/payments/${secret}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get method
   *
   * @param {string} code
   * @param {string} providerCode
   * @param {Object} options - The additional request options
   * @description Get single payment method
   * @returns {Promise}
   */
  getPaymentMethod(providerCode, code, options = {}) {
    return this.apiClient.request({
      url: `/odr/methods/${providerCode}/${code}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get list of available payment methods
   *
   * @param {string} secret
   * @param {Object} options - The additional request options
   * @description Returns a list of payment methods available for the transaction
   * @returns {Promise}
   */
  listMethodsForTransaction(secret, options = {}) {
    return this.apiClient.request({
      url: `/odr/transactions/${secret}/methods`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get list of available payment methods
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of payment methods
   * @returns {Promise}
   */
  listPaymentMethods(options = {}) {
    return this.apiClient.request({
      url: `/odr/methods`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Mark paid
   *
   * @param {string} secret
   * @param {Object} options - The additional request options
   * @description Marks a payment as paid
   * @returns {Promise}
   */
  markPaymentAsPaid(secret, options = {}) {
    return this.apiClient.request({
      url: `/odr/payments/${secret}/paid`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Start payment
   *
   * @param {string} secret
   * @param {Object} options - The additional request options
   * @description Start a payment for a transaction at the provider
   * @returns {Promise}
   */
  startPaymentTransaction(secret, options = {}) {
    return this.apiClient.request({
      url: `/odr/payments/${secret}/start`,
      method: 'get',
      ...options,
    });
  }
}

export const payments = new Payments();

export default Payments;
